import { useEffect, useRef, useState } from 'react'
import SuperAdminService from '../../../../shared/services/super-admin/super-admin.service';
import { ISuperAdminOrganisation } from '../../../../shared/services/super-admin/super-admin.model';
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display';
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { useNavigate } from 'react-router-dom';
import { CustomTabPanel } from '../../../presentation-components/display-elements-components/custom-tab-panel';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import { a11yProps } from '../../../../shared/utils/misc-shared-utils';
import { SearchBar } from '../../../presentation-components/display-elements-components/search-bar';
import { LoadingPage } from '../../loading-page';
import { useDebounce } from '../../../../hooks/use-debounce-hook';

export const SuperAdminOrganisationsPage = () => {
  const navigate = useNavigate();
  //Services
  const superAdminService = new SuperAdminService();
  //State
  const [value, setValue] = useState(0);
  const [organisations, setOrganisations] = useState<ISuperAdminOrganisation[]>([]);
  const [searchQuery, setSearchQuery] = useState('')
  //Table State
  const [selected, setSelected] = useState<string[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [change, setChange] = useState<number>(0)
  //Loading State
  const [hasPageMounted, setHasPageMounted] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  //Hooks
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  //Ref
  const requestId = useRef<number>(0)

  useEffect(() => {
    requestId.current++
    const currentRequestId = requestId.current
    superAdminService.getAllOrganisationsWithPagination(value === 0 ? true : false, debouncedSearchQuery, inputPage, perPage)
      .then(response => {
        if (currentRequestId === requestId.current) {
          setTotalRecords(response.count)
          setIsLoading(false)
          setOrganisations(response.rows)
        }
      })
      .catch(err => {
        if (currentRequestId === requestId.current) {
          setIsLoading(false)
        }
        console.log(err)
      })
  }, [inputPage, perPage, change])

  useEffect(() => {
    if (hasPageMounted) {
      if (inputPage === 0) {
        setChange(change + 1)
      } else {
        setInputPage(0)
      }
    }
    setHasPageMounted(true)
  }, [value, debouncedSearchQuery])



  const headCells: IHeadCell[] = [
    { id: 'name', numeric: false, label: 'Name', sortable: false },
    ...(value === 1 ? [{ id: 'freeTrialDaysRemaining', numeric: true, label: 'Trial Days Remaining', sortable: false }] : []),
  ];

  const rows = organisations.map(organisation => {
    return {
      id: organisation.id,
      name: organisation.name,
      ...(value === 1 ? { freeTrialDaysRemaining: organisation.freeTrialDaysRemaining } : {}),
    }
  });

  const handleSelected = (selectedRowId: string[]) => {
    if (selectedRowId[0] !== undefined) {
      navigate(`/super-admin/organisations/${selectedRowId[0]}`)
    }
  }

  //Component Event Handlers
  const changeTabHandler = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setIsLoading(true)
    setSearchQuery('')
  };

  return (
    <PageOuterContainer>
      <PageHeading
        title='Super Admin Organisations'
        includeBackButton={true}
        backButtonLink='/super-admin'
        backButtonText='Back to super admin'
        hasTabs={true}
      />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={changeTabHandler} aria-label="basic tabs example">
          <Tab label="Subscription" {...a11yProps(0)} />
          <Tab label="No Subscription" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Grid container sx={{ mb: 2 }}>
          <Grid
            item
            xl={4} lg={4} md={6} sm={12} xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              width: '100%'
            }}>
            <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          </Grid>
        </Grid>
        <LoadingPage pageReady={!isLoading}>
          {organisations &&
            <TableDisplay
              headCells={headCells}
              rows={rows}
              handleSelected={handleSelected}
              selected={selected}
              setSelected={setSelected}
              inputPage={inputPage}
              setInputPage={setInputPage}
              totalRecords={totalRecords}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          }
        </LoadingPage>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Grid container sx={{ mb: 2 }}>
          <Grid
            item
            xl={4} lg={4} md={6} sm={12} xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              width: '100%'
            }}>
            <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          </Grid>
        </Grid>
        <LoadingPage pageReady={!isLoading}>
          {organisations &&
            <TableDisplay
              headCells={headCells}
              rows={rows}
              handleSelected={handleSelected}
              selected={selected}
              setSelected={setSelected}
              inputPage={inputPage}
              setInputPage={setInputPage}
              totalRecords={totalRecords}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          }
        </LoadingPage>
      </CustomTabPanel>
    </PageOuterContainer>)
}